import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import type { AssigneeOption } from '@/types/work'

const UNASSIGNED = '__unassigned__'

interface AssigneePickerProps {
  value: number | null
  options: AssigneeOption[]
  onChange: (id: number | null) => void
  disabled?: boolean
  placeholder?: string
}

// v1: flat list of users in the actor's visibility perimeter (filtered
// .kept on the server, see PR #84). Role-aware filtering (member sees
// only supervisor; supervisor sees subtree) is deferred to 5b — the
// ReassignTask interaction enforces hierarchy at write time, so a
// crafted PATCH still gets rejected with 403.
export function AssigneePicker({
  value,
  options,
  onChange,
  disabled,
  placeholder = 'Sélectionner un assigné…',
}: AssigneePickerProps) {
  return (
    <Select
      value={value === null ? UNASSIGNED : String(value)}
      onValueChange={(v) => onChange(v === UNASSIGNED ? null : Number(v))}
      disabled={disabled}
    >
      <SelectTrigger>
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value={UNASSIGNED}>Non assigné</SelectItem>
        {options.map((opt) => (
          <SelectItem key={opt.id} value={String(opt.id)}>
            {opt.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}
